import { SENSOR_STATES } from '@linearb/linjs-common';
import { FILTER_TYPES } from 'common/constants/filters';
import { formatIssueTypes } from 'common/fetch/pmProvider/fetchJiraOnpremEntities';
import { getAllEntitiesByEntityType } from 'components/FilterMenus/FilterMenus.service';
import { uniqBy } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { pmIntegrationSelector } from 'state/selectors/sensors-authorizations';

const INITIALIZED_STATE = { data: [], loading: true };

const useIssueTypes = () => {
  const pmSensor = useSelector(pmIntegrationSelector);
  const sensorId = pmSensor?.sensor_id;
  const isAuthorized = pmSensor?.state === SENSOR_STATES.ok;

  const [issueTypes, setIssueTypes] = useState(INITIALIZED_STATE);

  const fetchIssuesTypes = async () => {
    try {
      let data;
      setIssueTypes({ data: [], loading: true });
      if (!isAuthorized) {
        data = { items: [], loading: false };
      } else {
        const { items: allIssueTypes } = await getAllEntitiesByEntityType(
          sensorId,
          FILTER_TYPES.ISSUE_TYPES
        );
        const formattedData = formatIssueTypes(uniqBy(allIssueTypes, 'value'));
        data = { items: formattedData };
      }
      setIssueTypes({ data: data?.items ?? [], loading: false });
    } catch {
      setIssueTypes(INITIALIZED_STATE);
    }
  };

  useEffect(() => {
    fetchIssuesTypes();
  }, []);

  return issueTypes;
};

export default useIssueTypes;
